import React from 'react'
import './styles/Compras.css'

const Compras = () => {
    return (
        <div id='compras'>
            <h2> Compras</h2>
            <div className='compras-text'>
            <p>Lorem ipsum dolor sit.</p>
            <p>Lorem ipsum dolor sit, amet consectetur adipisicing el
            it. Quibusdam quas tenetur nostrum saepe unde exercitationem neque velit expedita excepturi repellat.</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Numquam impedit accusantium aliquam?</p>
            <p>Lorem Ipsun!</p>
            </div>
        </div>
    )
}

export default Compras
